<template>
  <div class="product-card">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ProductCard'
}
</script>
<style lang="scss" scoped>
  .product-card {
    position: relative;
    height: 216px;
    width: 140px;
    padding: 10px 15px;
    border-radius: 6px;
    background-color: #FFFFFF;

    @media (min-width: $screen-lg) {
      height: 320px;
      width: 212px;
    }
  }
</style>
